<div class="business-login-footer">
  <div class="business-login-footer__urls">
    <div class="urls__first-section">
      <ion-text class="title">{{'LOGIN.FOOTER.INSURANCES.TITLE' | translate}}</ion-text>
      <ion-text (click)="url.open('https://www.mapfre.es/empresas')">{{'LOGIN.FOOTER.INSURANCES.BUSINESS_AND_HERITAGE' | translate}}</ion-text>
      <ion-text (click)="url.open('https://www.mapfre.es/empresas')">{{'LOGIN.FOOTER.INSURANCES.CIVIL_RESPONSIBILITY' | translate}}</ion-text>
      <ion-text (click)="url.open('https://www.mapfre.es/empresas')">{{'LOGIN.FOOTER.INSURANCES.VEHICLES_AND_FLEETS' | translate}}</ion-text>
      <ion-text (click)="url.open('https://www.mapfre.es/empresas')">{{'LOGIN.FOOTER.INSURANCES.EMPLOYEE' | translate}}</ion-text>
    </div>
    <div class="urls__second-section">
      <ion-text class="title">{{'LOGIN.FOOTER.LEGAL.TITLE' | translate}}</ion-text>
      <ion-text (click)="openPrivacyPolicyBusiness()">{{'LOGIN.FOOTER.LEGAL.PRIVACITY_AND_SECURITY' | translate}}</ion-text>
      <ion-text (click)="showCookieSettings()">{{'LOGIN.FOOTER.LEGAL.COOKIES_SETTINGS' | translate}}</ion-text>
    </div>
  </div>
  <div class="business-login-footer__info">
    <ion-text class="ion-text-center" (click)="url.open('https://www.mapfre.es/empresas')">{{'LOGIN.FOOTER.COPYRIGHT' | translate}}</ion-text>
    <div class="info__social">
      <img
        src="assets/images/login/business-phone-icon.svg"
        alt=""
        (click)="url.open('https://www.mapfre.es/movil')"
      >
      <img
        src="assets/images/login/business-instagram-icon.svg"
        alt=""
        (click)="url.open('https://www.instagram.com/mapfre_es/')"
      >
      <img
        src="assets/images/login/business-facebook-icon.svg"
        alt=""
        (click)="url.open('https://es-es.facebook.com/MAPFRE.ES/')"
      >
      <img
        src="assets/images/login/business-twitter-icon.svg"
        alt=""
        (click)="url.open('https://twitter.com/MAPFRE_ES')"
      >
      <img
        src="assets/images/login/business-youtube-icon.svg"
        alt=""
        (click)="url.open('https://www.youtube.com/user/mapfretecuidamos')"
      >
      <img
        src="assets/images/login/business-linkedin-icon.svg"
        alt=""
        (click)="url.open('https://www.linkedin.com/company/mapfre/')"
      >
    </div>
  </div>
</div>
